<template>
  <component :is="way" v-bind="{ ...$props, ...$attrs }" v-on="$listeners" />
</template>

<script>
import { mapState } from 'vuex';
import ProcessRow from '@/components/invites/ProcessRowDefault.vue';
import PROCESS_NAMES from '@/process/names';

const SportmasterInvitesRow = () =>
  import(
    /* webpackChunkName: "sportmaster-invites-row" */ '@/process/sportmaster/components/invites/ProcessRow.vue'
  );

export default {
  name: 'InvitesProcessRow',

  components: {
    default: ProcessRow,
    sportmaster: SportmasterInvitesRow
  },

  computed: {
    ...mapState('process', ['companyCommonSpecialProcess']),

    way() {
      // const process = this.$store.getters["company/process"];
      if (this.companyCommonSpecialProcess !== undefined) {
        if (this.companyCommonSpecialProcess === PROCESS_NAMES.SPORTMASTER) {
          return 'sportmaster';
        }
      }

      return 'default';
    }
  }
};
</script>
